import { render, staticRenderFns } from "./BankAccountCreationForm.vue?vue&type=template&id=17865d77"
import script from "./BankAccountCreationForm.vue?vue&type=script&lang=js"
export * from "./BankAccountCreationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports